@if (inputModel) {
  <div>
    <label>{{label}}</label>
    <span>{{inputModel}}</span>
    <hr />
  </div>
}